import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, Route } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import styles from '../../../resources/theme/global'
import { renderRoute } from '../../../util/utils'
import { fetchBillingType } from '../BillingTypeActions'
import { getBillingTypeListData } from '../BillingTypeReducer'

import Edit from './Edit'
import Filter from './Filter'
import List from './List'
import New from './New'

class BillingType extends Component {
  componentDidMount() {
    const { fetchBillingType } = this.props
    fetchBillingType()
  }

  render() {
    const { classes, items, permissions } = this.props

    return (
      <>
        <Grid
          container
          className={classes.pageHead}
          spacing={1}
          alignItems="center"
        >
          <Grid item xs>
            <Typography variant="h4" color="secondary">
              Tipo de conta
            </Typography>
          </Grid>
          <Grid item>
            <Filter classes={classes} />
          </Grid>
          <Grid item>
            {renderRoute(['create-billing-type'], permissions) && (
              <Button
                color="primary"
                variant="contained"
                component={Link}
                to="/billing-type/new"
              >
                <AddCircleOutlineIcon className={classes.btnIcon} /> Cadastrar
              </Button>
            )}
          </Grid>
        </Grid>

        {renderRoute(['create-billing-type'], permissions) && (
          <Route path="/billing-type/new" component={New} />
        )}

        {renderRoute(['update-billing-type'], permissions) && (
          <Route path="/billing-type/:id/edit" component={Edit} />
        )}

        <List permissions={permissions} classes={classes} items={items} />
      </>
    )
  }
}

const mapStateToProps = state => ({
  ...getBillingTypeListData(state),
  permissions: state.auth.permissions || [],
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchBillingType,
    },
    dispatch
  )
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(BillingType))
